export const LESSON_DURATION: number = 60; //minutes
export const LESSON_START_HOUR: number = 8;